import React, { ReactElement } from 'react';
import { VoidCallback } from 'types';
import EditStudentModalForm from './EditStudentModalForm';

interface EditStudentModalProps {
  onSubmitSuccess: VoidCallback;
  onClose: VoidCallback;
}

const EditStudentModal = (props: EditStudentModalProps): ReactElement => {
  return <EditStudentModalForm {...props} />;
};

export default EditStudentModal;
